import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Heading from '../../../generic-components/Heading';
import Button from '../../../generic-components/Button';
import { ReactComponent as IconAlert } from '../../../assets/icons/svg/stamp-icons/ic-stamp-alert.svg';
import { VIEWS_MAP } from '../../../router/constants';
import { ERROR_DATA } from '../constants';

const { STYLES } = ERROR_DATA;

interface IProps {
  enrollErrorData: {errCode: number, errMsg: string};
}

const ACH_OUT_ERRORS_MAP = {
  ACH_OUT_EXCEED_DAY_SUM_LIMIT: 4240,
  ACH_OUT_EXCEED_MONTH_SUM_LIMIT: 4241,
  ACH_OUT_EXCEED_MONTH_COUNT_LIMIT: 4242,
  ACH_OUT_FEE_EXPIRED: 4243,
  ACH_OUT_INSUFFICIENT_BALANCE: 4244,
  ACH_OUT_EXCEED_DAY_COUNT_LIMIT: 4245,
};

const ErrorEnrollAchOut = ({ enrollErrorData }: IProps) => {
  const [errData, setErrData] = useState<{errHead: string}>({ errHead: '' });
  const navigate = useNavigate();
  const { t } = useTranslation();

  const isAddFunds = useMemo(() => {
    if (enrollErrorData.errCode === ACH_OUT_ERRORS_MAP.ACH_OUT_INSUFFICIENT_BALANCE) {
      return true;
    }
    return false;
  }, [enrollErrorData.errCode]);

  const handleSubmit = () => {
    if (isAddFunds) {
      navigate(`/${VIEWS_MAP.ACH_TRANSFER}`);
    } else {
      navigate(`/${VIEWS_MAP.DASHBOARD}`);
    }
  };

  function getErrorData() {
    switch (enrollErrorData.errCode) {
      case ACH_OUT_ERRORS_MAP.ACH_OUT_EXCEED_DAY_SUM_LIMIT:
        setErrData({ errHead: t('ACH_OUT_ERROR_HEADERS.EXCEED_DAY_SUM_LIMIT') });
        break;
      case ACH_OUT_ERRORS_MAP.ACH_OUT_EXCEED_MONTH_SUM_LIMIT:
        setErrData({ errHead: t('ACH_OUT_ERROR_HEADERS.EXCEED_MONTH_SUM_LIMIT') });
        break;
      case ACH_OUT_ERRORS_MAP.ACH_OUT_EXCEED_MONTH_COUNT_LIMIT:
        setErrData({ errHead: t('ACH_OUT_ERROR_HEADERS.EXCEED_MONTH_COUNT_LIMIT') });
        break;
      case ACH_OUT_ERRORS_MAP.ACH_OUT_EXCEED_DAY_COUNT_LIMIT:
        setErrData({ errHead: t('ACH_OUT_ERROR_HEADERS.EXCEED_DAY_COUNT_LIMIT') });
        break;
      case ACH_OUT_ERRORS_MAP.ACH_OUT_INSUFFICIENT_BALANCE:
        setErrData({ errHead: t('ACH_OUT_ERROR_HEADERS.INSUFFICIENT_BALANCE') });
        break;
      default:
        setErrData({ errHead: t('ACH_OUT_ERROR_HEADERS.EXCEED_DAY_SUM_LIMIT') });
        break;
    }
  }

  useEffect(() => {
    getErrorData();
  }, [enrollErrorData.errCode]);

  return (
    <div className={STYLES.CONTAINER}>
      <IconAlert className={STYLES.ICON} />
      <Heading title={errData.errHead} className={STYLES.MAIN_HEAD} testId='BankTransferLimitErrorTitle' />
      <Heading title={enrollErrorData.errMsg} className={STYLES.DESC} testId='BankTransferLimitErrorMessage' />
      <div className={STYLES.CTAS_WRAPPER}>
        <Button testId='BankTransferLimitErrorSubmitButton' onClick={handleSubmit} title={isAddFunds ? t('ACH_OUT_ERROR_CTA.ADD_FUNDS') : t('ACH_OUT_ERROR_CTA.GOT_IT')} className={STYLES.MAIN_CTA} id='errorStepCtaA' />
        {isAddFunds && <Button testId='BankTransferLimitNotNowButton' onClick={() => navigate(`/${VIEWS_MAP.DASHBOARD}`)} title={t('ACH_OUT_ERROR_CTA.NOT_NOW')} className={STYLES.SEC_CTA} id='errorStepCtaB' />}
      </div>
    </div>
  );
};

export default ErrorEnrollAchOut;
